/**
 * Insurance Message Requests Routes
 */
/* eslint-disable */
import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";

// async components
import {
  AsyncManageMessageRequestsComponent,
  AsyncAddMessageRequestComponent,
  AsyncModifyMessageRequestComponent,
} from "../../components/AsyncComponent/AsyncComponent";

const Forms = ({ match }) => (
  <React.Fragment>
    <Switch>
      <Redirect exact from={`${match.url}/`} to={`${match.url}/manage`} />
      <Route
        path={`${match.url}/view-all`}
        component={AsyncManageMessageRequestsComponent}
      />
      <Route
        path={`${match.url}/create`}
        component={AsyncAddMessageRequestComponent}
      />
      <Route
        path={`${match.url}/modify`}
        component={AsyncModifyMessageRequestComponent}
      />
    </Switch>
  </React.Fragment>
);

export default Forms;
